import { useState, useRef, useCallback } from 'react';

interface OnceSonraItem {
  id: number;
  baslik: string;
  kategori: string;
  sure: string;
  onceGorsel: string;
  sonraGorsel: string;
}

const veriler: OnceSonraItem[] = [
  {
    id: 1,
    baslik: 'Cilt Yenileme Paketi',
    kategori: 'Cilt Bakımı',
    sure: '3 Seans',
    onceGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20face%20skin%20before%20treatment%20uneven%20skin%20tone%20dark%20spots%20blemishes%20dull%20complexion%20natural%20lighting%20no%20makeup%20neutral%20background%20clinical%20photo&width=600&height=700&seq=once001&orientation=portrait',
    sonraGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20face%20skin%20after%20treatment%20glowing%20radiant%20smooth%20even%20skin%20tone%20clear%20complexion%20natural%20lighting%20no%20makeup%20neutral%20background%20clinical%20photo&width=600&height=700&seq=sonra001&orientation=portrait',
  },
  {
    id: 2,
    baslik: 'Lazer Epilasyon',
    kategori: 'Lazer',
    sure: '6 Seans',
    onceGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20leg%20skin%20before%20laser%20hair%20removal%20visible%20hair%20follicles%20dark%20hair%20stubble%20natural%20skin%20texture%20clinical%20photo%20neutral%20background&width=600&height=700&seq=once002&orientation=portrait',
    sonraGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20leg%20skin%20after%20laser%20hair%20removal%20smooth%20silky%20hairless%20skin%20perfect%20texture%20clinical%20photo%20neutral%20background&width=600&height=700&seq=sonra002&orientation=portrait',
  },
  {
    id: 3,
    baslik: 'Kalıcı Makyaj',
    kategori: 'Kalıcı Makyaj',
    sure: '1 Seans',
    onceGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20eyebrows%20before%20microblading%20sparse%20thin%20uneven%20eyebrows%20natural%20face%20no%20makeup%20neutral%20background%20clinical%20beauty%20photo&width=600&height=700&seq=once003&orientation=portrait',
    sonraGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20eyebrows%20after%20microblading%20perfect%20defined%20full%20natural%20looking%20eyebrows%20beautiful%20face%20neutral%20background%20clinical%20beauty%20photo&width=600&height=700&seq=sonra003&orientation=portrait',
  },
  {
    id: 4,
    baslik: 'Leke Tedavisi',
    kategori: 'Cilt Bakımı',
    sure: '4 Seans',
    onceGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20face%20cheek%20before%20pigmentation%20treatment%20dark%20spots%20hyperpigmentation%20melasma%20uneven%20skin%20tone%20clinical%20photo%20neutral%20background&width=600&height=700&seq=once004&orientation=portrait',
    sonraGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20face%20cheek%20after%20pigmentation%20treatment%20clear%20even%20skin%20tone%20no%20dark%20spots%20bright%20radiant%20complexion%20clinical%20photo%20neutral%20background&width=600&height=700&seq=sonra004&orientation=portrait',
  },
  {
    id: 5,
    baslik: 'Vücut Sıkılaştırma',
    kategori: 'Vücut Bakımı',
    sure: '8 Seans',
    onceGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20abdomen%20before%20body%20contouring%20treatment%20loose%20skin%20cellulite%20natural%20body%20clinical%20photo%20neutral%20background&width=600&height=700&seq=once005&orientation=portrait',
    sonraGorsel: 'https://readdy.ai/api/search-image?query=close%20up%20female%20abdomen%20after%20body%20contouring%20treatment%20toned%20firm%20smooth%20skin%20defined%20contour%20clinical%20photo%20neutral%20background&width=600&height=700&seq=sonra005&orientation=portrait',
  },
];

function SliderKart({ item }: { item: OnceSonraItem }) {
  const [sliderPos, setSliderPos] = useState(50);
  const [dragging, setDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const getPos = useCallback((clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setSliderPos((x / rect.width) * 100);
  }, []);

  const onMouseDown = () => setDragging(true);
  const onMouseMove = (e: React.MouseEvent) => { if (dragging) getPos(e.clientX); };
  const onMouseUp = () => setDragging(false);
  const onTouchMove = (e: React.TouchEvent) => getPos(e.touches[0].clientX);

  return (
    <div className="rounded-2xl overflow-hidden border border-white/10 group"
      style={{ background: 'rgba(255,255,255,0.04)' }}>
      {/* Slider Alanı */}
      <div
        ref={containerRef}
        className="relative h-72 md:h-80 select-none overflow-hidden cursor-col-resize"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
        onTouchMove={onTouchMove}
        onTouchStart={() => setDragging(true)}
        onTouchEnd={() => setDragging(false)}
      >
        {/* SONRA görseli (arka plan) */}
        <div className="absolute inset-0">
          <img
            src={item.sonraGorsel}
            alt={`${item.baslik} sonra`}
            className="w-full h-full object-cover object-top"
            draggable={false}
          />
          {/* Sonra etiketi */}
          <div className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-black text-[#1A0F0A]"
            style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}>
            SONRA
          </div>
        </div>

        {/* ÖNCE görseli (clip ile) */}
        <div
          className="absolute inset-0 overflow-hidden"
          style={{ clipPath: `inset(0 ${100 - sliderPos}% 0 0)` }}
        >
          <img
            src={item.onceGorsel}
            alt={`${item.baslik} önce`}
            className="w-full h-full object-cover object-top"
            draggable={false}
          />
          {/* Önce etiketi */}
          <div className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-bold text-white/80 border border-white/25"
            style={{ background: 'rgba(26,15,10,0.7)', backdropFilter: 'blur(6px)' }}>
            ÖNCE
          </div>
        </div>

        {/* Slider çizgisi */}
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-white/90 pointer-events-none"
          style={{ left: `${sliderPos}%`, transform: 'translateX(-50%)' }}
        >
          {/* Tutamaç */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center border-2 border-white/80"
            style={{ background: 'rgba(26,15,10,0.85)', backdropFilter: 'blur(8px)' }}>
            <i className="ri-arrow-left-right-line text-white text-sm"></i>
          </div>
        </div>

        {/* Sürükle ipucu */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-white/50 text-xs pointer-events-none transition-opacity duration-300 group-hover:opacity-0"
          style={{ background: 'rgba(26,15,10,0.6)', backdropFilter: 'blur(6px)' }}>
          <i className="ri-drag-move-line mr-1"></i>Kaydır
        </div>
      </div>

      {/* Kart Bilgisi */}
      <div className="p-4 flex items-center justify-between">
        <div>
          <p className="text-white font-semibold text-sm">{item.baslik}</p>
          <p className="text-white/40 text-xs mt-0.5">{item.kategori}</p>
        </div>
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#E8B86D]/25"
          style={{ background: 'rgba(232,184,109,0.08)' }}>
          <i className="ri-time-line text-[#E8B86D] text-xs"></i>
          <span className="text-[#E8B86D] text-xs font-medium">{item.sure}</span>
        </div>
      </div>
    </div>
  );
}

export default function OnceSonra() {
  const [aktifSayfa, setAktifSayfa] = useState(0);
  const sayfaBoyutu = 3;
  const toplamSayfa = Math.ceil(veriler.length / sayfaBoyutu);
  const gosterilen = veriler.slice(aktifSayfa * sayfaBoyutu, aktifSayfa * sayfaBoyutu + sayfaBoyutu);

  return (
    <section className="py-20 md:py-28" style={{ background: '#1A0F0A' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Başlık */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-5 py-2 text-[#E8B86D] text-xs font-bold tracking-[0.2em] uppercase rounded-full mb-5 border border-[#E8B86D]/25"
            style={{ background: 'rgba(232,184,109,0.1)' }}>
            Gerçek Sonuçlar
          </span>
          <h2
            className="font-black italic text-white leading-tight mb-4"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.8rem, 4vw, 3rem)' }}
          >
            Önce &amp;{' '}
            <span style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Sonra
            </span>
          </h2>
          <p className="text-white/50 text-sm md:text-base max-w-lg mx-auto font-light">
            Müşterilerimizin gerçek dönüşüm hikâyeleri — görseli kaydırarak farkı kendiniz görün
          </p>
        </div>

        {/* Kartlar */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {gosterilen.map((item) => (
            <SliderKart key={item.id} item={item} />
          ))}
        </div>

        {/* Sayfalama */}
        {toplamSayfa > 1 && (
          <div className="flex items-center justify-center gap-2 mb-10">
            {Array.from({ length: toplamSayfa }).map((_, i) => (
              <button
                key={i}
                onClick={() => setAktifSayfa(i)}
                className="transition-all duration-300 rounded-full cursor-pointer"
                style={
                  aktifSayfa === i
                    ? { width: '28px', height: '8px', background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }
                    : { width: '8px', height: '8px', background: 'rgba(255,255,255,0.2)' }
                }
              />
            ))}
          </div>
        )}

        {/* Alt bilgi bandı */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {[
            { ikon: 'ri-user-smile-line', sayi: '5.000+', metin: 'Mutlu Müşteri' },
            { ikon: 'ri-star-fill', sayi: '5.0', metin: 'Ortalama Puan' },
            { ikon: 'ri-shield-check-line', sayi: '%100', metin: 'Güvenli Uygulama' },
          ].map((stat, i) => (
            <div key={i} className="flex items-center justify-center gap-3 py-4 rounded-xl border border-white/10"
              style={{ background: 'rgba(255,255,255,0.04)' }}>
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#E8B86D]/25"
                style={{ background: 'rgba(232,184,109,0.1)' }}>
                <i className={`${stat.ikon} text-[#E8B86D] text-lg`}></i>
              </div>
              <div>
                <p className="text-white font-black text-lg leading-none">{stat.sayi}</p>
                <p className="text-white/40 text-xs mt-0.5">{stat.metin}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="https://wa.me/905001234567?text=Merhaba, önce sonra sonuçları hakkında bilgi almak istiyorum."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#1A0F0A] px-8 py-3.5 rounded-full font-black text-sm transition-all whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Siz de Dönüşümünüzü Başlatın
          </a>
        </div>
      </div>
    </section>
  );
}
